module.exports = __webpack_public_path__ + "img/sobre.e6fc7c88.jpg";